export enum DashStatuses {
  Ordered = 'Ordered',
  Permitted = 'Permitted',
  Delivered = 'Delivered',
  Installed = 'Installed',
  Inspected = 'Inspected',
  Activated = 'Activated',
  Pending = 'Pending',
  // This must be changed to either 'Canceled' or 'Cancelled' in the future
  Cancelled = 'Cancelled',
  Canceled = 'Canceled',
}

export enum StatusCode {
  NoStatus = 'NoStatus',
  ReviewLead = 'ReviewLead',
  Reviewed = 'Reviewed',
  Disqualified = 'Disqualified',
  Complete = 'Complete',
  // This must be changed to either 'Canceled' or 'Cancelled' in the future
  Cancelled = 'Cancelled',
  Canceled = 'Canceled',
  ProposalProcessing = 'ProposalProcessing',
  ProposalReady = 'ProposalReady',
  ProposalAccepted = 'ProposalAccepted',
  ProposalLost = 'ProposalLost',
  OrderToDo = 'OrderToDo',
  OrderPending = 'OrderPending',
  OrderProcessing = 'OrderProcessing',
  PermitProcessing = 'PermitProcessing',
  PermitReady = 'PermitReady',
  DeliveryToDo = 'DeliveryToDo',
  DeliveryProcessing = 'DeliveryProcessing',
  DeliveryInTransit = 'DeliveryInTransit',
  InstallToDo = 'InstallToDo',
  InstallConfirmed = 'InstallConfirmed',
  InspectionConfirmed = 'InspectionConfirmed',
  ActivationInProgress = 'ActivationInProgress',
  Received = 'Received',
}

export enum StatusColor {
  DarkBlue = '#2774aE',
  Grey = '#75787b',
  LightBlue = '#d6e3ee',
  White = '#fff',
}

export enum StatusIcon {
  Done = 'done',
  Warning = 'warning',
}

export type Status = {
  code: StatusCode;
  title: string;
  mainColor: StatusColor;
  backgroundColor: StatusColor;
  icon: StatusIcon | null;
  final: boolean;
  canceled: boolean;
};

export type StatusesMap = {
  [key in StatusCode]: Status;
};

export const STATUSES_MAP: StatusesMap = {
  [StatusCode.NoStatus]: {
    code: StatusCode.NoStatus,
    title: 'null',
    mainColor: StatusColor.White,
    backgroundColor: StatusColor.White,
    icon: null,
    final: false,
    canceled: false,
  },
  [StatusCode.ReviewLead]: {
    code: StatusCode.ReviewLead,
    title: 'REVIEW LEAD',
    mainColor: StatusColor.DarkBlue,
    backgroundColor: StatusColor.White,
    icon: StatusIcon.Warning,
    final: false,
    canceled: false,
  },
  [StatusCode.Reviewed]: {
    code: StatusCode.Reviewed,
    title: 'REVIEWED',
    mainColor: StatusColor.DarkBlue,
    backgroundColor: StatusColor.DarkBlue,
    icon: null,
    final: false,
    canceled: false,
  },
  [StatusCode.Disqualified]: {
    code: StatusCode.Disqualified,
    title: 'DISQUALIFIED',
    mainColor: StatusColor.Grey,
    backgroundColor: StatusColor.Grey,
    icon: null,
    final: true,
    canceled: false,
  },
  [StatusCode.Complete]: {
    code: StatusCode.Complete,
    title: 'COMPLETE',
    mainColor: StatusColor.DarkBlue,
    backgroundColor: StatusColor.DarkBlue,
    icon: StatusIcon.Done,
    final: true,
    canceled: false,
  },
  [StatusCode.Cancelled]: {
    code: StatusCode.Cancelled,
    title: 'CANCELLED',
    mainColor: StatusColor.Grey,
    backgroundColor: StatusColor.Grey,
    icon: null,
    final: true,
    canceled: true,
  },
  [StatusCode.Canceled]: {
    code: StatusCode.Canceled,
    title: 'CANCELLED',
    mainColor: StatusColor.Grey,
    backgroundColor: StatusColor.Grey,
    icon: null,
    final: true,
    canceled: true,
  },
  [StatusCode.ProposalProcessing]: {
    code: StatusCode.ProposalProcessing,
    title: 'PROCESSING',
    mainColor: StatusColor.DarkBlue,
    backgroundColor: StatusColor.LightBlue,
    icon: null,
    final: false,
    canceled: false,
  },
  [StatusCode.ProposalReady]: {
    code: StatusCode.ProposalReady,
    title: 'PROPOSAL READY',
    mainColor: StatusColor.DarkBlue,
    backgroundColor: StatusColor.White,
    icon: StatusIcon.Warning,
    final: false,
    canceled: false,
  },
  [StatusCode.ProposalAccepted]: {
    code: StatusCode.ProposalAccepted,
    title: 'ACCEPTED',
    mainColor: StatusColor.DarkBlue,
    backgroundColor: StatusColor.DarkBlue,
    icon: StatusIcon.Done,
    final: true,
    canceled: false,
  },
  [StatusCode.ProposalLost]: {
    code: StatusCode.ProposalLost,
    title: 'LOST',
    mainColor: StatusColor.Grey,
    backgroundColor: StatusColor.Grey,
    icon: null,
    final: true,
    canceled: true,
  },
  [StatusCode.OrderToDo]: {
    code: StatusCode.OrderToDo,
    title: 'TO-DO',
    mainColor: StatusColor.Grey,
    backgroundColor: StatusColor.White,
    icon: null,
    final: false,
    canceled: false,
  },
  [StatusCode.OrderPending]: {
    code: StatusCode.OrderPending,
    title: 'PENDING',
    mainColor: StatusColor.DarkBlue,
    backgroundColor: StatusColor.White,
    icon: StatusIcon.Warning,
    final: false,
    canceled: false,
  },
  [StatusCode.OrderProcessing]: {
    code: StatusCode.OrderProcessing,
    title: 'PROCESSING',
    mainColor: StatusColor.DarkBlue,
    backgroundColor: StatusColor.LightBlue,
    icon: null,
    final: false,
    canceled: false,
  },
  [StatusCode.PermitProcessing]: {
    code: StatusCode.PermitProcessing,
    title: 'PROCESSING',
    mainColor: StatusColor.DarkBlue,
    backgroundColor: StatusColor.LightBlue,
    icon: null,
    final: false,
    canceled: false,
  },
  [StatusCode.PermitReady]: {
    code: StatusCode.PermitReady,
    title: 'PERMIT PACK READY',
    mainColor: StatusColor.DarkBlue,
    backgroundColor: StatusColor.White,
    icon: StatusIcon.Warning,
    final: false,
    canceled: false,
  },
  [StatusCode.DeliveryToDo]: {
    code: StatusCode.DeliveryToDo,
    title: 'TO-DO',
    mainColor: StatusColor.Grey,
    backgroundColor: StatusColor.White,
    icon: null,
    final: false,
    canceled: false,
  },
  [StatusCode.DeliveryProcessing]: {
    code: StatusCode.DeliveryProcessing,
    title: 'PROCESSING',
    mainColor: StatusColor.DarkBlue,
    backgroundColor: StatusColor.LightBlue,
    icon: null,
    final: false,
    canceled: false,
  },
  [StatusCode.DeliveryInTransit]: {
    code: StatusCode.DeliveryInTransit,
    title: 'IN TRANSIT',
    mainColor: StatusColor.DarkBlue,
    backgroundColor: StatusColor.LightBlue,
    icon: null,
    final: false,
    canceled: false,
  },
  [StatusCode.InstallToDo]: {
    code: StatusCode.InstallToDo,
    title: 'TO-DO',
    mainColor: StatusColor.Grey,
    backgroundColor: StatusColor.White,
    icon: null,
    final: false,
    canceled: false,
  },
  [StatusCode.InstallConfirmed]: {
    code: StatusCode.InstallConfirmed,
    title: 'CONFIRMED',
    mainColor: StatusColor.DarkBlue,
    backgroundColor: StatusColor.LightBlue,
    icon: null,
    final: false,
    canceled: false,
  },
  [StatusCode.InspectionConfirmed]: {
    code: StatusCode.InspectionConfirmed,
    title: 'CONFIRMED',
    mainColor: StatusColor.DarkBlue,
    backgroundColor: StatusColor.LightBlue,
    icon: null,
    final: false,
    canceled: false,
  },
  [StatusCode.ActivationInProgress]: {
    code: StatusCode.ActivationInProgress,
    title: 'IN PROGRESS',
    mainColor: StatusColor.DarkBlue,
    backgroundColor: StatusColor.LightBlue,
    icon: null,
    final: false,
    canceled: false,
  },
  [StatusCode.Received]: {
    code: StatusCode.Received,
    title: 'RECEIVED',
    mainColor: StatusColor.DarkBlue,
    backgroundColor: StatusColor.LightBlue,
    icon: null,
    final: false,
    canceled: false,
  },
};
